import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f1fa0ce2")

_pushScopeId("data-v-f1fa0ce2")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Documenti")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "documenti_switcher" }
const _hoisted_5 = {
  key: 0,
  class: "no_documents_container_detail"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "no_documents" }, "Nessun documento caricato", -1)
const _hoisted_7 = { class: "documenti_container" }
const _hoisted_8 = {
  key: 0,
  class: "download_document"
}
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "document_info" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = {
  class: "date",
  style: {"margin-bottom":"4px"}
}
const _hoisted_13 = {
  key: 0,
  class: "status"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "badge badge_danger" }, "Scaduto", -1)
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { class: "icon" }
const _hoisted_17 = { class: "document_info" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = {
  class: "date",
  style: {"margin-bottom":"4px"}
}
const _hoisted_20 = {
  key: 0,
  class: "status"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "badge badge_danger" }, "Scaduto", -1)
const _hoisted_22 = {
  key: 1,
  style: {"display":"none"}
}
const _hoisted_23 = {
  key: 0,
  class: "no_documents_container_detail"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "no_documents" }, "Nessun documento caricato", -1)
const _hoisted_25 = { class: "documenti_container" }
const _hoisted_26 = {
  key: 0,
  class: "download_document"
}
const _hoisted_27 = { class: "info" }
const _hoisted_28 = { class: "document_info" }
const _hoisted_29 = { class: "title" }
const _hoisted_30 = {
  key: 0,
  class: "status"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "badge badge_danger" }, "Scaduto", -1)
const _hoisted_32 = { class: "info" }
const _hoisted_33 = { class: "icon" }
const _hoisted_34 = { class: "document_info" }
const _hoisted_35 = { class: "title" }
const _hoisted_36 = {
  key: 0,
  class: "status"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("span", { class: "badge badge_danger" }, "Scaduto", -1)
const _hoisted_38 = {
  key: 2,
  style: {"display":"none"}
}
const _hoisted_39 = {
  key: 0,
  class: "no_documents_container_detail"
}
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "no_documents" }, "Nessun cedolino caricato", -1)
const _hoisted_41 = { class: "documenti_container" }
const _hoisted_42 = {
  key: 0,
  class: "download_document"
}
const _hoisted_43 = { class: "info" }
const _hoisted_44 = { class: "document_info" }
const _hoisted_45 = { class: "title" }
const _hoisted_46 = {
  key: 0,
  class: "status"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("span", { class: "badge badge_danger" }, "Scaduto", -1)
const _hoisted_48 = { class: "info" }
const _hoisted_49 = { class: "icon" }
const _hoisted_50 = { class: "document_info" }
const _hoisted_51 = { class: "title" }
const _hoisted_52 = {
  key: 0,
  class: "status"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "badge badge_danger" }, "Scaduto", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadDocuments()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.categorieDocumenti, (category, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: ["type", [$setup.selectedDocumentType == category.documenti_dipendenti_categoria_id ? 'active' : '']],
                      onClick: ($event: any) => ($setup.setActiveDocuments(`${category.documenti_dipendenti_categoria_id}`))
                    }, _toDisplayString(category.documenti_dipendenti_categoria_value), 11, ["onClick"]))
                  }), 128))
                ]),
                ($setup.documentsToShow.length == 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _hoisted_6
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_7, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.documentsToShow, (documento) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "documento",
                      key: documento.documenti_dipendenti_id
                    }, [
                      (!documento.documenti_dipendenti_file)
                        ? (_openBlock(), _createBlock("div", _hoisted_8, [
                            _createVNode("div", _hoisted_9, [
                              _createVNode("div", _hoisted_10, [
                                _createVNode("div", _hoisted_11, _toDisplayString(documento.documenti_dipendenti_nome_documento), 1),
                                _createVNode("div", _hoisted_12, _toDisplayString(documento.documenti_dipendenti_sottocategorie_nome), 1),
                                _createVNode("div", {
                                  class: ["date", { date_expired: $setup.documentoScaduto(documento) }]
                                }, " Data scadenza: " + _toDisplayString($setup.dateFormat(documento.documenti_dipendenti_data_scadenza)), 3)
                              ])
                            ]),
                            ($setup.documentoScaduto(documento))
                              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                                  _hoisted_14
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createBlock("a", {
                            key: 1,
                            href: $setup.setAttachmentUrl(documento),
                            target: "_blank",
                            class: "download_document"
                          }, [
                            _createVNode("div", _hoisted_15, [
                              _createVNode("div", _hoisted_16, [
                                _createVNode(_component_ion_icon, { icon: $setup.attach }, null, 8, ["icon"])
                              ]),
                              _createVNode("div", _hoisted_17, [
                                _createVNode("div", _hoisted_18, _toDisplayString(documento.documenti_dipendenti_nome_documento), 1),
                                _createVNode("div", _hoisted_19, _toDisplayString(documento.documenti_dipendenti_sottocategorie_nome), 1),
                                _createVNode("div", {
                                  class: ["date", { date_expired: $setup.documentoScaduto(documento) }]
                                }, " Data scadenza: " + _toDisplayString($setup.dateFormat(documento.documenti_dipendenti_data_scadenza)), 3)
                              ])
                            ]),
                            ($setup.documentoScaduto(documento))
                              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                                  _hoisted_21
                                ]))
                              : _createCommentVNode("", true)
                          ], 8, ["href"]))
                    ]))
                  }), 128))
                ]),
                ($setup.showGenerali)
                  ? (_openBlock(), _createBlock("div", _hoisted_22, [
                      ($setup.documenti_generali.length == 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_23, [
                            _hoisted_24
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_25, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.documenti_generali, (documento) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "documento",
                            key: documento.documenti_dipendenti_id
                          }, [
                            (!documento.documenti_dipendenti_file)
                              ? (_openBlock(), _createBlock("div", _hoisted_26, [
                                  _createVNode("div", _hoisted_27, [
                                    _createVNode("div", _hoisted_28, [
                                      _createVNode("div", _hoisted_29, _toDisplayString(documento.documenti_dipendenti_nome_documento), 1),
                                      _createVNode("div", {
                                        class: ["date", { date_expired: $setup.documentoScaduto(documento) }]
                                      }, " Data scadenza: " + _toDisplayString($setup.dateFormat(documento.documenti_dipendenti_data_scadenza)), 3)
                                    ])
                                  ]),
                                  ($setup.documentoScaduto(documento))
                                    ? (_openBlock(), _createBlock("div", _hoisted_30, [
                                        _hoisted_31
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createBlock("a", {
                                  key: 1,
                                  href: $setup.setAttachmentUrl(documento),
                                  target: "_blank",
                                  class: "download_document"
                                }, [
                                  _createVNode("div", _hoisted_32, [
                                    _createVNode("div", _hoisted_33, [
                                      _createVNode(_component_ion_icon, { icon: $setup.attach }, null, 8, ["icon"])
                                    ]),
                                    _createVNode("div", _hoisted_34, [
                                      _createVNode("div", _hoisted_35, _toDisplayString(documento.documenti_dipendenti_nome_documento), 1),
                                      _createVNode("div", {
                                        class: ["date", { date_expired: $setup.documentoScaduto(documento) }]
                                      }, " Data scadenza: " + _toDisplayString($setup.dateFormat(documento.documenti_dipendenti_data_scadenza)), 3)
                                    ])
                                  ]),
                                  ($setup.documentoScaduto(documento))
                                    ? (_openBlock(), _createBlock("div", _hoisted_36, [
                                        _hoisted_37
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 8, ["href"]))
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_38, [
                      ($setup.documenti_cedolino.length == 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_39, [
                            _hoisted_40
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_41, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.documenti_cedolino, (documento) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "documento",
                            key: documento.documenti_dipendenti_id
                          }, [
                            (!documento.documenti_dipendenti_file)
                              ? (_openBlock(), _createBlock("div", _hoisted_42, [
                                  _createVNode("div", _hoisted_43, [
                                    _createVNode("div", _hoisted_44, [
                                      _createVNode("div", _hoisted_45, _toDisplayString(documento.documenti_dipendenti_nome_documento), 1),
                                      _createVNode("div", {
                                        class: ["date", { date_expired: $setup.documentoScaduto(documento) }]
                                      }, " Data scadenza: " + _toDisplayString($setup.dateFormat(documento.documenti_dipendenti_data_scadenza)), 3)
                                    ])
                                  ]),
                                  ($setup.documentoScaduto(documento))
                                    ? (_openBlock(), _createBlock("div", _hoisted_46, [
                                        _hoisted_47
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createBlock("a", {
                                  key: 1,
                                  href: $setup.setAttachmentUrl(documento),
                                  target: "_blank",
                                  class: "download_document"
                                }, [
                                  _createVNode("div", _hoisted_48, [
                                    _createVNode("div", _hoisted_49, [
                                      _createVNode(_component_ion_icon, { icon: $setup.attach }, null, 8, ["icon"])
                                    ]),
                                    _createVNode("div", _hoisted_50, [
                                      _createVNode("div", _hoisted_51, _toDisplayString(documento.documenti_dipendenti_nome_documento), 1),
                                      _createVNode("div", {
                                        class: ["date", { date_expired: $setup.documentoScaduto(documento) }]
                                      }, " Data scadenza: " + _toDisplayString($setup.dateFormat(documento.documenti_dipendenti_data_scadenza)), 3)
                                    ])
                                  ]),
                                  ($setup.documentoScaduto(documento))
                                    ? (_openBlock(), _createBlock("div", _hoisted_52, [
                                        _hoisted_53
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 8, ["href"]))
                          ]))
                        }), 128))
                      ])
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})